import React from 'react';
import PropTypes from 'prop-types';

const Bank = ({ width = 88, className = '' }) => (
  <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={width}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <path d="M12 3L2 9h20L12 3z" />
      <path d="M4 9v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9" />
      <path d="M7 20V9" />
      <path d="M12 20V9" />
      <path d="M17 20V9" />
      <path d="M5 9h14" />
      <path d="M5 20h14" />
    </svg>
);

Bank.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
};

export default Bank;
